<script lang="ts">
  import ImageOrVideo from "@shared/svelte/Components/ImageOrVideo.svelte";
  import { cloudinaryParams } from "@shared/services/discovery_image_dimensions";
  import { getCloudinaryUrl } from "@shared/services/cloudinary_image_url_service";

  import type {
    MiniStoriesContentCardAdEntity,
    MiniStoriesContentCardEntity,
  } from "@shared/services/event_tracking/entities";

  export let description: string;
  export let imageAltText: string = "";
  export let imageUrl: string | null;
  export let index: number;
  export let title: string;
  export let trackingParams: (MiniStoriesContentCardAdEntity | MiniStoriesContentCardEntity)[] = [];
  export let useThumbnail: boolean;
  export let videoUploadUrl: string | null;
  export let displaySponsoredLabel: boolean = false;

  // If the mini story is not a sponsored ad programmed via ads manager, it will be in IMAGE_PATHS.
  // Otherwise, the server will serve the full url.
  const cloudinaryImageParams = cloudinaryParams.miniStory;
  const fullImageUrl: string =
    window["C"].IMAGE_PATHS[imageUrl] || getCloudinaryUrl(imageUrl, cloudinaryImageParams);
</script>

<div
  class="fizz-flex-vertical fizz-space-between"
  style="height: 100%; flex-direction: column; align-items: flex-start"
>
  <figure style="margin-right: 0">
    <div class="fizz-overflow-hidden">
      <ImageOrVideo
        {imageAltText}
        imageUploadUrl={fullImageUrl}
        {index}
        objectPrefix={"featured_content_mini_story"}
        {trackingParams}
        {useThumbnail}
        {videoUploadUrl}
      />
    </div>

    <figcaption class="fizz-inset-square-16">
      {#if displaySponsoredLabel}
        <div
          class="fizz-flex-row fizz-stack-8 fizz-justify-start"
          data-testid="title-sponsored-label"
        >
          <div class="fizz-text-small fizz-text-subdued">Sponsored</div>
        </div>
      {/if}

      <p class="fizz-text-large fizz-stack-8">
        {#if title}
          <strong>{title}</strong>
        {/if}
      </p>
      <p>
        {#if description}
          {description}
        {/if}
      </p>
    </figcaption>
  </figure>
  <div class="fizz-inset-square-16">
    <button class="fizz-button-primary fizz-button-small">Learn More</button>
  </div>
</div>
